import { TranslocoHelper } from '@core/helpers/transloco.helper';
import { MeasurementTypeEnum, OrderByEnum } from '@oranta-mis/sdk';
import { ColumnFilterEnum, TableColumn, TableColumnTypeEnum } from '@oranta-mis/ui-library';

export const measurementListColumnHeader = (i18n: TranslocoHelper): TableColumn[] => [
  { type: TableColumnTypeEnum.person_with_route, key: 'person', name: i18n.tr('patient'), minWidth: '300px' },
  {
    type: TableColumnTypeEnum.text,
    key: 'type',
    name: i18n.tr('type'),
    filters: {
      type: ColumnFilterEnum.multiselect,
      options: [
        { label: i18n.tr('ecg'), value: MeasurementTypeEnum.ecg },
        { label: i18n.tr('osc'), value: MeasurementTypeEnum.os },
        { label: i18n.tr('posture'), value: MeasurementTypeEnum.posture },
        { label: i18n.tr('infrared'), value: MeasurementTypeEnum.infrared },
        { label: i18n.tr('motion_sensor'), value: MeasurementTypeEnum.motion_sensor },
        { label: i18n.tr('measurement.body_size'), value: MeasurementTypeEnum.body_size },
        { label: i18n.tr('measurement.gait'), value: MeasurementTypeEnum.gait },
        { label: i18n.tr('pulsogram'), value: MeasurementTypeEnum.pulsogram },
        { label: i18n.tr('weight'), value: MeasurementTypeEnum.weight },
      ],
      appliedFilter: null,
    },
  },
  { type: TableColumnTypeEnum.text, key: 'info', name: i18n.tr('info') },
  {
    type: TableColumnTypeEnum.text,
    key: 'registrationDate',
    name: i18n.tr('measurement.date_registration'),
    sort: { sortable: true, orderBy: OrderByEnum.desc },
  },
  {
    type: TableColumnTypeEnum.text,
    key: 'createdAt',
    name: i18n.tr('created_at'),
    sort: { sortable: true, orderBy: null },
  },
  { type: TableColumnTypeEnum.checkbox, key: 'select', name: '' },
  { type: TableColumnTypeEnum.actions, key: 'actions', name: i18n.tr('actions'), actions: ['identify'] },
];
